import React from 'react';

import { convertCamelCaseToWords, getArrayLength, getObjectPropertyValue, getTableCellValue_string, isArray, isArrayNotEmpty, isNumberValid, isObjectNotEmpty, isStringTrimNotEmpty } from 'functions';

export const companyInfoColumns = {
    // Columns Array
    getColumns,

    // Columns (User)
    getColumns_userEmail,
    getColumns_firstName,
    getColumns_lastName,
    getColumns_isUserActive,

    // Column (Company)
    getColumns_company_dbServerName,
    getColumns_company_id,
    getColumns_company_name,
    getColumns_company_adminEmail,
    getColumns_company_serverName,
    getColumns_company_isSuspended,
    getColumns_company_isDeleted,
    getColumns_company_appVersion,
    getColumns_company_dbVersion,
    getColumns_company_dbVersionDate
}

function getColumns({ userEmail, userName, isGettingUsersForComId, isUserColumnDetailVisible }) {
    let userColumns = [
        getColumns_userEmail(),
        getColumns_firstName(),
        getColumns_lastName(),
        getColumns_isUserActive(),
    ];

    let companyColumns = [
        getColumns_company_dbServerName(),
        getColumns_company_id(),
        getColumns_company_name(),
        getColumns_company_adminEmail(),
        getColumns_company_serverName(),
        getColumns_company_isSuspended(),
        getColumns_company_isDeleted(),
        getColumns_company_appVersion(),
        getColumns_company_dbVersion(),
        getColumns_company_dbVersionDate()
    ]

    let actualColumns = [];
    if (isUserColumnDetailVisible) {
        actualColumns = actualColumns.concat(userColumns).concat(companyColumns);
    }
    else actualColumns = actualColumns.concat(companyColumns);

    return actualColumns;
}


function getColumns_company_dbServerName() {
    let columnClassName = "table-column__company-db-server-name";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "DB Server Name",
        id: "dbServerName",
        accessor: "DBServer",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_company_id() {
    let columnClassName = "table-column__company-id";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "COM ID",
        id: "comId",
        accessor: "ComId",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = getObjectPropertyValue(props, "cell");
            let value = getObjectPropertyValue(cell, "value");
            let value_formatted = isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_company_name() {
    let columnClassName = "table-column__company-name";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "COM Name",
        id: "companyName",
        accessor: "ComName",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}


function getColumns_userEmail() {
    let columnClassName = "table-column__user-email";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "User Email",
        id: "userEmail",
        accessor: "UserEmail",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_firstName() {
    let columnClassName = "table-column__first-name";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "First Name",
        id: "firstName",
        accessor: "FirstName",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_lastName() {
    let columnClassName = "table-column__last-name";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Last Name",
        id: "lastName",
        accessor: "LastName",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_isUserActive() {
    let columnClassName = "table-column__is-user-active";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Is Active",
        id: "isUserActive",
        accessor: "Active",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_company_adminEmail() {
    let columnClassName = "table-column__company-admin-email";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Admin Email",
        id: "adminEmail",
        accessor: "AdminEmail",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_company_serverName() {
    let columnClassName = "table-column__company-server-name";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Server Name",
        id: "serverName",
        accessor: "ServerName",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_company_isSuspended() {
    let columnClassName = "table-column__company-is-suspended";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Is Suspended",
        id: "isSuspended",
        accessor: "Suspended",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_company_isDeleted() {
    let columnClassName = "table-column__company-is-deleted";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Is Deleted",
        id: "isDeleted",
        accessor: "Deleted",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_company_appVersion() {
    let columnClassName = "table-column__company-app-version";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "App Version",
        id: "appVersion",
        accessor: "AppVersion",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_company_dbVersion() {
    let columnClassName = "table-column__company-db-version";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "DB Version",
        id: "dbVersion",
        accessor: "DBVersion",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}

function getColumns_company_dbVersionDate() {
    let columnClassName = "table-column__company-db-version-date";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "DB Version Date",
        id: "dbVersionDate",
        accessor: "DBVersionDate",
        bodyCellClassName: columnClassName + " align-items-center ",
        Cell: (props) => {
            return (
                <div className={"noWrap-text-ellipsis"}>{getTableCellValue_string(props, "")}</div>
            );
        },
    }
}